(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("precise-ui"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "precise-ui"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("precise-ui")) : factory(root["react"], root["precise-ui"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, function(__WEBPACK_EXTERNAL_MODULE__156__, __WEBPACK_EXTERNAL_MODULE__290__) {
return 